/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShopOrderDetailDto } from '../../models/shop-order-detail-dto';

export interface ShopOrderAdminControllerFindByIdV1$Params {

/**
 * 주문 ID
 */
  id: string;
}

export function shopOrderAdminControllerFindByIdV1(http: HttpClient, rootUrl: string, params: ShopOrderAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderDetailDto>> {
  const rb = new RequestBuilder(rootUrl, shopOrderAdminControllerFindByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShopOrderDetailDto>;
    })
  );
}

shopOrderAdminControllerFindByIdV1.PATH = '/api/v1/shop-orders/admin/{id}';
